import { render } from "./HomeNav.vue?vue&type=template&id=f4f4e6f8&scoped=true&ts=true"
import script from "./HomeNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeNav.vue?vue&type=script&setup=true&lang=ts"

import "./HomeNav.vue?vue&type=style&index=0&id=f4f4e6f8&scoped=true&lang=scss"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f4e6f8"],['__file',"src/components/home/HomeNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4f4e6f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4f4e6f8', __exports__)) {
    console.log('reload')
    api.reload('f4f4e6f8', __exports__)
  }
  
  module.hot.accept("./HomeNav.vue?vue&type=template&id=f4f4e6f8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f4f4e6f8', render)
  })

}


export default __exports__